export default __webpack_public_path__ + "static/media/esf.ff6d54a0.png";